import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdgroupCheckGuardGuard } from './shared/common/adgroup-check-guard.guard';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    //canActivate: [AdgroupCheckGuardGuard]

  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule),

  },
  // {
  //   path: 'covid-lite-home',
  //   loadChildren: () => import('./covid-lite-home/covid-lite-home.module').then(m => m.CovidLiteHomeModule)
  // },
  {
    path: 'facility-admin',
    loadChildren: () => import('./facility-admin/facility-admin.module').then(m => m.FacilityAdminModule)
  },
  {
    path: 'facility-home',
    loadChildren: () => import('./facility-profile/facility-profile.module').then(m => m.FacilityProfileModule)
  },
  {
    path: "access-denied",
    component: AccessDeniedComponent
  },
  {
    path: 'outreach-user',
    loadChildren: () => import('./outreach-user/outreach-user.module').then(m => m.OutreachUserModule)
  },
  {
    path: 'r3ap',
    loadChildren: () => import('./facility-admin/facility-admin.module').then(m => m.FacilityAdminModule)
  },
  {
    path: 'icf',
    loadChildren: () => import('./icf-facility/icf-facility.module').then(m => m.IcfFacilityModule)
  },
  {
    path: 'dodd-admin',
    loadChildren: () => import('./dodd-admin/dodd-admin.module').then(m => m.DoddAdminModule)
  }
  ,
  {
    path: 'tap',
    loadChildren: () => import('./tap-home/tap-home.module').then(m => m.TapHomeModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
